import { useQuery } from '@tanstack/react-query';
import { apiRequest } from '../../lib/apiClient.js';
import { queryKeys } from '../../lib/queryKeys.js';
import type { UserListResponse } from '../../lib/types.js';

interface UsersListLogic {
  isLoading: boolean;
  data: UserListResponse | undefined;
  error: Error | null;
  refetch: () => void;
}

export const useUsersListLogic = (tenantId: string | undefined): UsersListLogic => {
  const query = useQuery<UserListResponse>({
    queryKey: queryKeys.users(tenantId ?? ''),
    queryFn: () => apiRequest<UserListResponse>(`/api/users`),
    enabled: Boolean(tenantId),
  });

  return {
    isLoading: query.isLoading,
    data: query.data,
    error: query.error,
    refetch: () => void query.refetch(),
  };
};
